import { Organizer } from "../../../../../../../shared/types/OrganizerTypes"
import { getOrderPerson, getOrganizerPhone } from "../../../../../../../shared/utils/getOrderPerson"

export interface ContactInfo {
    creator?: Organizer
    meetingHost?: Organizer
    showBoth: boolean
}

type OrderCustomer = Readonly<{
    displayName?: string
    email?: string
}>

export const getContactInfo = (organizers?: Organizer[], customer?: OrderCustomer): ContactInfo => {
    if (!organizers || organizers.length === 0) {
        return customer?.displayName
            ? { meetingHost: { name: customer.displayName, email: customer.email }, showBoth: false }
            : { showBoth: false }
    }
    const { creator, person: meetingHost } = getOrderPerson(organizers)

    // If creator and meeting host are the same person, show only meeting host
    if (creator && meetingHost && creator.name === meetingHost.name && creator.email === meetingHost.email) {
        return {
            meetingHost,
            showBoth: false,
        }
    }
    return {
        creator,
        meetingHost,
        showBoth: true,
    }
}

export function hasContactDetails({ creator, meetingHost }: ContactInfo) {
    return [creator, meetingHost].some((contact) => Boolean(contact?.email || getOrganizerPhone(contact)))
}
